/**
 *
 * @module paywallManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class PaywallManagerConfiguration
 *
 */
export default class PaywallManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/paywallManagerConfiguration.js